export default __webpack_public_path__ + "static/media/SEH004-LUX-Exterior-layout.2466b2b9.jpg";